var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 3V6.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8333 3V6.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8333 4.875C24.9958 5.1 27.0833 6.6875 27.0833 12.5625V20.2875C27.0833 25.4375 25.8333 28.0125 19.5833 28.0125H12.0833C5.83331 28.0125 4.58331 25.4375 4.58331 20.2875V12.5625C4.58331 6.6875 6.67081 5.1125 10.8333 4.875H20.8333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.7708 22.5H4.89581",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.1624 15.4431L14.8405 15.0429L14.19 14.5994C13.7668 14.3109 13.4958 13.8732 13.4958 13.275C13.4958 12.6108 13.7545 12.1405 14.1498 11.8253C14.5583 11.4994 15.1492 11.3125 15.8333 11.3125C16.5173 11.3125 17.1044 11.4993 17.5095 11.8243C17.9014 12.1388 18.1583 12.6091 18.1583 13.275C18.1583 13.8737 17.8992 14.2996 17.4622 14.6007L16.8033 15.0546L17.5 15.4479C18.1247 15.8006 18.4583 16.3755 18.4583 17.0375C18.4583 17.6712 18.2193 18.152 17.8045 18.4852C17.3774 18.8284 16.7183 19.05 15.8333 19.05C14.9414 19.05 14.2829 18.8281 13.858 18.4857C13.4455 18.1533 13.2083 17.6729 13.2083 17.0375C13.2083 16.3782 13.5401 15.8104 14.1624 15.4431ZM14.2083 13.3625C14.2083 13.8076 14.3855 14.1976 14.6995 14.4699C15.0067 14.7363 15.4114 14.8625 15.8333 14.8625C16.2552 14.8625 16.66 14.7363 16.9671 14.4699C17.2812 14.1976 17.4583 13.8076 17.4583 13.3625C17.4583 12.9125 17.2819 12.5221 16.962 12.2522C16.6517 11.9905 16.2471 11.875 15.8333 11.875C15.4195 11.875 15.0149 11.9905 14.7046 12.2522C14.3847 12.5221 14.2083 12.9125 14.2083 13.3625ZM13.9083 16.8375C13.9083 17.3611 14.1251 17.7996 14.5045 18.0947C14.8692 18.3784 15.3442 18.5 15.8333 18.5C16.3225 18.5 16.7974 18.3784 17.1622 18.0947C17.5415 17.7996 17.7583 17.3611 17.7583 16.8375C17.7583 16.3173 17.5392 15.8822 17.1606 15.5901C16.7965 15.3091 16.3225 15.1875 15.8333 15.1875C15.3474 15.1875 14.873 15.3045 14.5075 15.5842C14.1259 15.8763 13.9083 16.3131 13.9083 16.8375Z",
    fill: "white",
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.6ecaf503076ac4c02160b8cff5e7bcb2.svg";
export { ForwardRef as ReactComponent };